import "./App.css";

import React, { useState, useRef, useMemo, useEffect} from "react";

import Card from "./components/Card";
import ScreenImage from "./components/ScreenImage";
import Title from "./components/Title";
import ScrollVideo from "./components/ScrollVideo";
import GraphicMat from "./components/GraphicMat";
import { ProgressBar } from "./components/ProgressBar";
import LoadingSpinner from "./components/LoadingSpinner";
import NavBar from "./components/NavBar";


import { processData } from "./data/process";
import desktop_data from "./data/desktop_data";

// process content/data

console.log(desktop_data);

function DesktopApp() {
  const {
    frames,
    slides: allSlides,
  } = useMemo(() => {
    return processData(desktop_data);
  }, []);

  const [currentSlide, setCurrentSlide] = useState(0);
  //console.log(currentSlide);

  const ref = useRef();
  const TOTAL_FRAMES = 927;
  const FIFTH_FRAMES = 150; 

  const [imgsLoaded, setImgsLoaded] = useState(false)

  useEffect(() => {

    const imgs = []
    for  (var i = 0; i < FIFTH_FRAMES; i++){
        const formattedFrame = i.toString().padStart(3, "0");
        imgs[i]=`Frames/AlSina_Frame${formattedFrame}.jpg`
    }
    //console.log (imgs)

    const promises  = imgs.map ((src)=> {
      return new Promise ((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => resolve(img));
        img.addEventListener('error', (err) => reject(err));
        img.src = src;
      });
    });

    Promise.all(promises).then((res) =>
    setImgsLoaded(true));
    }, []);

    useEffect(() => {

      const imgs = []
      for  (var i = FIFTH_FRAMES; i < TOTAL_FRAMES; i++){
          const formattedFrame = i.toString().padStart(3, "0");
          imgs[i]=`Frames/AlSina_Frame${formattedFrame}.jpg`
      }
      //console.log (imgs)
  
      const promises  = imgs.map ((src)=> {
        return new Promise ((resolve, reject) => {
          const img = new Image();
          img.addEventListener('load', () => resolve(img));
          img.addEventListener('error', (err) => reject(err));
          img.src = src;
        });
      });
      }, []);

    const allWrapperStyle = {
      position: "relative",
      overflowY: "scroll",
      overflowX: "hidden",
      height: "100vh",
    }


  const renderSlides = (slides) => {
    return (
      <div id="all-cards-container">
        <Card
          slidesContent={slides}
          callbackFromParent={setCurrentSlide}
        />
      </div>
    );
  };

  return (
    imgsLoaded ? (
    <div id={"all"} ref={ref} style={allWrapperStyle}>
    <NavBar isMobile={false} elementId="all"/>  
    <ProgressBar elementId="all"/>  
    {ref.current ? (
    <ScrollVideo
          divRef={ref}
          chapterStartSlide={0}
          currentSlide={allSlides[currentSlide]}
          videoSettings={frames}
          isMobile={false}
        />
      ) : null}
    <ScreenImage isMobile={false} currentSlide={allSlides[currentSlide]} />
    <Title isMobile={false} currentSlide={allSlides[currentSlide]} />
    <GraphicMat isMobile={false} currentSlide={allSlides[currentSlide]} />
    {renderSlides(allSlides)}
    </div>)    
    : (<LoadingSpinner isMobile={false}/>)
    );
  }

export default DesktopApp